import React, { useRef } from 'react';
import {
  AppBar,
  Toolbar,
  Dialog,
  Typography,
  IconButton,
  DialogContent,
  DialogActions,
  useMediaQuery,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Actions, useDispatchProvider, useStateDialogCustomer } from '../utils/StateProvider';
import FormCustomer from '../forms/FormCustomer';

const DialogCustomer = () => {
  const portalRef = useRef(null);
  const stateDialogCustomer = useStateDialogCustomer();
  const dispatch = useDispatchProvider();
  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    dispatch &&
      dispatch({
        type: Actions.DialogCustomer,
        payload: false,
      });

    dispatch &&
      dispatch({
        type: Actions.FormCustomerPhone,
        payload: '',
      });
  };
  return (
    <Dialog
      open={stateDialogCustomer}
      onClose={handleDialogClose}
      maxWidth={'sm'}
      fullWidth={true}
      fullScreen={useMediaQuery((theme) => theme.breakpoints.down('md'))}
    >
      <AppBar position={'sticky'}>
        <Toolbar>
          <IconButton
            autoFocus
            size="large"
            edge="start"
            color="inherit"
            aria-label="close"
            sx={{ mr: 2 }}
            onClick={handleDialogClose}
          >
            <Close />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          >
            Customer Details
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent dividers={true}>
        <FormCustomer portalRef={portalRef} />
      </DialogContent>
      <DialogActions
        sx={{ paddingX: 3, paddingY: 2 }}
        ref={portalRef}
      ></DialogActions>
      {/*  <Button*/}
      {/*    color={'primary'}*/}
      {/*    variant={'contained'}*/}
      {/*    startIcon={<PersonAddAlt1 />}*/}
      {/*    // onClick={addProduct}*/}
      {/*    size={'large'}*/}
      {/*  >*/}
      {/*    Create*/}
      {/*  </Button>*/}
      {/*</DialogActions>*/}
    </Dialog>
  );
};

export default DialogCustomer;
